

export const wanExamples = {
    title: 'Wan 2.5 原生音訊影片範例',
    sub: '看看 Wan 2.5 如何將文字與圖片轉化為完整的音視覺體驗',
    imageToVideoTitle: '圖片轉影片（含音訊）',
    imageToVideoDesc: '將靜態圖片轉化為具同步配樂、對白與環境音的動態影片，在保留視覺一致性的同時加入真實運動與原生音訊。',
    sectionLabel: '輸入',
    textToVideoTitle: '文字轉影片（原生音訊）',
    textToVideoDesc: '僅依文字描述即可生成完整影片，包含視覺、對白與音樂。原生音訊與唇形、場景節奏精準對齊，呈現電影級效果。',
    promptText: '「夜幕降臨，昏暗的爵士酒吧里，溫暖的吊燈映照著木桌。顧客啜飲著飲品，輕聲交談，台上三人樂隊正在演奏。薩克斯風手站在聚光燈下，閃亮的樂器映照著燈光。沒有對話。環境音效：薩克斯風和鋼琴奏出的流暢爵士樂，杯盞碰撞的清脆聲，觀眾低聲交談，偶爾從鄰桌傳來一陣笑聲。鏡頭：慢慢掃過人群，然後輕輕拉近，聚焦於薩克斯風手的獨奏，著重展現他富有表現力的手部動作」'
  };
